var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVgc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "38 74 133 60",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.83,76.69l9.54,43.9,9.55-43.9H80.76l-14.1,55.1H53.72l-14.1-55.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.87,113.36v1.3c-.15,11.64-5.79,18-18.44,18-13.38,0-18.73-7-18.73-19.74V95.71c0-12.87,5.42-19.89,18.73-19.89,12.36,0,18.36,6.3,18.36,18v.8h-10.7v-1c0-5.71-2.6-8.38-7.66-8.38-6.58,0-8.25,3.76-8.25,10.84v16.42c0,7.08,1.52,10.77,8.25,10.77,5.35,0,7.59-2.53,7.81-8.46v-1.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7,94.26v-.57c-.07-11.72-6.14-17.87-19.16-17.87S85.16,82.4,85.16,95.64v17.43c0,12.8,5.64,19.59,19.24,19.59s19.23-6.22,19.23-19.16V102.65H113.22l-8.82,8.82h9.11v2.82c0,6.3-2.6,9.19-8.82,9.19-7.31,0-9.26-2.82-9.26-10.49V95.78c0-7.52,2.53-10.63,9.11-10.63,6.15,0,9,2.39,9,8.32v.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgc);
export default __webpack_public_path__ + "static/media/vgc.f52999a3e99864c34be290b66981fbfb.svg";
export { ForwardRef as ReactComponent };